

























import Vue from 'vue';

const MIN_COL_WIDTH = 70;

export default Vue.extend({
  name: 'ColumnResizer',
  props: {
    columns: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      containerCss: {},
      handles: [],
      moving: null,
      oldHandlePosition: 0,
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateLayout);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLayout);
  },
  methods: {
    async updateLayout() {
      if (this.disabled) {
        return;
      }
      // Wait for render
      await this.$nextTick();
      this.setContainerSize();
      this.updateHandles();
    },
    setContainerSize() {
      const thead = this.$el.querySelector('thead');
      this.containerCss = {
        width: `${thead.offsetWidth}px`,
        height: `${thead.offsetHeight}px`,
      };
    },
    updateHandles() {
      this.handles = this.columns.reduce((list: any[], col) => {
        if (col.resizable === false) {
          return list;
        }
        const th = this.$el.querySelector(`[data-col-key="${col.key}"]`);
        if (th) {
          const pos = th.offsetLeft + th.offsetWidth;
          list.push({
            col,
            pos,
            style: {
              left: pos + 'px',
              height: this.containerCss.height,
            },
            class: null,
            th,
          });
        }
        return list;
      }, []);
    },
    mouseDownHandler(handle) {
      this.moving = handle;
      this.moving.class = 'moving';
      this.moving.oldWidth = this.moving.col.width || this.moving.th.offsetWidth;
      this.oldHandlePosition = this.moving.pos;
      this.setBodyStyles(true);

      document.body.addEventListener('mouseup', this.mouseUpHandler);
      document.body.addEventListener('mousemove', this.mouseMoveHandler);
      document.body.addEventListener('keydown', this.escHandler);
    },
    dblClickHandler(handle) {
      setTimeout(() => {
        this.$emit('columnSizeChange', handle.col.key, null);
      }, 10);
    },
    async mouseUpHandler() {
      if (this.moving && this.moving.col) {
        const newWidth = Math.max(this.moving.oldWidth - (this.oldHandlePosition - this.moving.pos), MIN_COL_WIDTH);

        if (this.moving.col.width === newWidth) {
          return;
        }

        // Set header width immediately
        const newPxWidth = newWidth + 'px';
        this.moving.th.style.setProperty('width', newPxWidth, 'important');
        this.moving.th.style.setProperty('min-width', newPxWidth, 'important');
        this.moving.th.style.setProperty('max-width', newPxWidth, 'important');

        // $nextTick doesn't wait for actual browser render
        setTimeout(() => {
          this.$emit('columnSizeChange', this.moving.col.key, newWidth);
          this.moving.class = null;
          this.moving = null;
          this.setBodyStyles(false);
        }, 0);
      } else {
        this.moving = null;
      }

      document.body.removeEventListener('mouseup', this.mouseUpHandler);
      document.body.removeEventListener('mousemove', this.mouseMoveHandler);
      document.body.removeEventListener('keydown', this.escHandler);
    },
    mouseMoveHandler(ev) {
      if (this.moving) {
        this.moving.pos = this.moving.pos + ev.movementX;
        this.moving.style.left = this.moving.pos + 'px';
      }
    },
    setBodyStyles(moving: Boolean) {
      if (moving) {
        document.body.style.setProperty('cursor', 'col-resize', 'important');
        document.body.style.setProperty('user-select', 'none', 'important');
      } else {
        document.body.style.setProperty('cursor', null);
        document.body.style.setProperty('user-select', null);
      }
    },
    escHandler(ev) {
      if (ev.key === 'Escape') {
        this.moving.pos = this.oldHandlePosition;
        this.moving.style.left = this.moving.pos + 'px';
        this.moving.class = null;
        this.moving = null;
        this.setBodyStyles(false);
      }
    },
  },
});
